// import React from "react";

// export default function Footer() {
//   return (
//     <footer className="bg-black text-white py-12">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center">
//           <div className="text-2xl font-bold mb-4">
//             HEXA ELECTRONICS PVT. LTD.
//           </div>
//           <p className="text-gray-400 mb-6">
//             Revolutionizing Nepal's dairy industry with cutting-edge technology
//             and innovative solutions.
//           </p>
//           <div className="flex justify-center items-center space-x-4 text-sm text-gray-400">
//             <span>© 2024 Hexa Electronics Pvt. Ltd.</span>
//             <span>•</span>
//             <span>ISO Certified</span>
//             <span>•</span>
//             <span>Made in Nepal</span>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

// import React from "react";
// import {
//   BrandFacebook,
//   BrandInstagram,
//   BrandLinkedin,
//   BrandYoutube,
// } from "tabler-icons-react";

// export default function Footer() {
//   return (
//     <footer className="bg-black text-white py-12">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Top Section */}
//         <div className="text-center mb-8">
//           <h2 className="text-2xl font-bold mb-4">
//             HEXA ELECTRONICS PVT. LTD.
//           </h2>
//           <p className="text-gray-400 max-w-2xl mx-auto">
//             Revolutionizing Nepal's dairy industry with cutting-edge technology
//             and innovative solutions.
//           </p>
//         </div>

//         {/* Middle Section: Links + Social */}
//         <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8 text-center md:text-left">
//           {/* Navigation Links */}
//           <div className="flex space-x-6 text-sm text-gray-300">
//             <a href="#products" className="hover:text-white transition">
//               Products onClick={() => scrollToId("products")}
//             </a>
//             <a href="#certificates" className="hover:text-white transition">
//               Certifications onClick={() => scrollToId("certificates")}
//             </a>
//             <a href="/contact" className="hover:text-white transition">
//               Contact
//             </a>
//           </div>

//           {/* Social Media Icons */}
//           <div className="flex space-x-5 text-gray-400">
//             <a
//               href="https://facebook.com"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="hover:text-white transition"
//             >
//               <BrandFacebook className="w-6 h-6" />
//             </a>
//             <a
//               href="https://instagram.com"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="hover:text-white transition"
//             >
//               <BrandInstagram className="w-6 h-6" />
//             </a>
//             <a
//               href="https://linkedin.com"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="hover:text-white transition"
//             >
//               <BrandLinkedin className="w-6 h-6" />
//             </a>
//             <a
//               href="https://youtube.com"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="hover:text-white transition"
//             >
//               <BrandYoutube className="w-6 h-6" />
//             </a>
//           </div>
//         </div>

//         {/* Bottom Section */}
//         <div className="text-center text-sm text-gray-500 border-t border-gray-700 pt-6">
//           <div className="space-x-4">
//             <span>© {new Date().getFullYear()} Hexa Electronics Pvt. Ltd.</span>
//             <span>•</span>
//             <span>ISO Certified</span>
//             <span>•</span>
//             <span>Made in Nepal</span>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

////scroll to certificate
import React from "react";
import {
  BrandFacebook,
  BrandInstagram,
  BrandLinkedin,
  BrandYoutube,
} from "tabler-icons-react";
import { colors } from "../Color";

export default function Footer({ onNavigateTab, onContactUs }) {
  // Scroll helper function
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      className="bg-black text-white py-12  "
      style={{
        backgroundColor: colors.primary, // fallback if image fails
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Section */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold mb-4">
            HEXA ELECTRONICS PVT. LTD.
          </h2>
          <p className=" max-w-2xl mx-auto">
            Revolutionizing Nepal's dairy industry with cutting-edge technology
            and innovative solutions.
          </p>
        </div>

        {/* Middle Section: Links + Social */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8 text-center md:text-left">
          {/* Navigation Links */}
          <div className="flex space-x-6 text-sm text-gray-300">
            <button
              onClick={() => onNavigateTab("product")}
              className="hover:text-white transition cursor-pointer bg-transparent border-none p-0"
            >
              Products
            </button>
            <button
              onClick={() => onNavigateTab("certificate")}
              className="hover:text-white transition cursor-pointer bg-transparent border-none p-0"
            >
              Certifications
            </button>
            {/* <a href="/contact" className="hover:text-white transition">
              Contact
            </a> */}
            <button
              onClick={onContactUs}
              className="hover:text-white transition cursor-pointer bg-transparent border-none p-0"
            >
              ContactUs
            </button>
          </div>

          {/* Social Media Icons */}
          <div className="flex space-x-5 text-gray-400">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition"
            >
              <BrandFacebook className="w-6 h-6" />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition"
            >
              <BrandInstagram className="w-6 h-6" />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition"
            >
              <BrandLinkedin className="w-6 h-6" />
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition"
            >
              <BrandYoutube className="w-6 h-6" />
            </a>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="text-center text-sm text  border-t border-gray-700 pt-6">
          <div className="space-x-4">
            <span>© {new Date().getFullYear()} Hexa Electronics Pvt. Ltd.</span>
            <span>•</span>
            <span>ISO Certified</span>
            <span>•</span>
            <span>Made in Nepal</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
